export const SalesLastMonthTypes = {
  IGetSalesLastMonthService: Symbol("IGetSalesLastMonthService"),
};
